import React from 'react';
import { MAX_TIERS, MAX_TIER_SECONDS, MIN_TIER_SECONDS, TierRow } from '../../utils/music-request';

/**
 * Bảng mức phát nhạc của streamer: 1 đến 5 dòng, mỗi dòng một giá (Ca) và một thời lượng (giây).
 * Component điều khiển từ ngoài (giá trị nằm ở form cha), khai ở mức module để không bị dựng lại.
 */

const inputCls =
  'h-11 w-full rounded-lg border border-[#C8CCD8] dark:border-slate-600 bg-white dark:bg-slate-700 px-3 text-base dark:text-white';

const MusicTierEditor: React.FC<{
  rows: TierRow[];
  onChange: (rows: TierRow[]) => void;
}> = ({ rows, onChange }) => {
  const update = (index: number, patch: Partial<TierRow>) =>
    onChange(rows.map((r, i) => (i === index ? { ...r, ...patch } : r)));

  const add = () => {
    if (rows.length >= MAX_TIERS) return;
    onChange([...rows, { price: '', seconds: '' }]);
  };

  const remove = (index: number) => {
    if (rows.length <= 1) return;
    onChange(rows.filter((_, i) => i !== index));
  };

  return (
    <div className="flex flex-col gap-2">
      <span className="text-sm">Bảng mức phát nhạc</span>
      <p className="text-xs text-gray-500 dark:text-gray-400">
        Người xem chọn một mức khi gửi bài. Mức sau phải có giá cao hơn và thời lượng dài hơn mức
        trước. Bài ngắn hơn thời lượng của mức đã chọn sẽ được phát hết bài.
      </p>
      {rows.map((row, i) => (
        <div key={i} className="flex items-end gap-2">
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <label htmlFor={`music-tier-price-${i}`} className="text-xs ui-muted">
              Giá (Ca)
            </label>
            <input
              id={`music-tier-price-${i}`}
              type="number"
              min={1}
              step={1}
              value={row.price}
              onChange={(e) => update(i, { price: e.target.value })}
              placeholder="VD: 50000"
              className={inputCls}
            />
          </div>
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <label htmlFor={`music-tier-seconds-${i}`} className="text-xs ui-muted">
              Thời lượng (giây)
            </label>
            <input
              id={`music-tier-seconds-${i}`}
              type="number"
              min={MIN_TIER_SECONDS}
              max={MAX_TIER_SECONDS}
              step={1}
              value={row.seconds}
              onChange={(e) => update(i, { seconds: e.target.value })}
              placeholder="VD: 30"
              className={inputCls}
            />
          </div>
          <button
            type="button"
            onClick={() => remove(i)}
            disabled={rows.length <= 1}
            aria-label={`Xoá mức ${i + 1}`}
            className="h-11 shrink-0 rounded-lg border border-[#C8CCD8] dark:border-slate-600 px-3 text-sm dark:text-white disabled:cursor-not-allowed disabled:opacity-50"
          >
            Xoá
          </button>
        </div>
      ))}
      <button
        type="button"
        onClick={add}
        disabled={rows.length >= MAX_TIERS}
        className="w-fit rounded-lg border border-[#C8CCD8] dark:border-slate-600 px-3 py-2 text-sm dark:text-white disabled:cursor-not-allowed disabled:opacity-50"
      >
        Thêm mức
      </button>
    </div>
  );
};

export default MusicTierEditor;
